import React from 'react';
import classnames from 'classnames';
import styles from './flexCenter.module.css';
export const FlexCenter = ({ children, fullHeight = false, classes, }) => {
    const classString = classnames(styles.FlexCenter, fullHeight && styles['FlexCenter-FullHeight'], classes);
    return React.createElement("div", { className: classString }, children);
};
